import { connect } from 'react-redux';
import _ from 'lodash';
import { loadInvites, generateInvite, revokeInvite } from '../actions/invites';
import InviteManager from '../components/invite_manager/invite_manager';

function mapStateToProps({ invites }) {
  return {
    invites: _.values(invites.generatedInvites),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadInvites: () => dispatch(loadInvites()),
    generateInvite: () => dispatch(generateInvite()),
    revokeInvite: id => dispatch(revokeInvite(id)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InviteManager);



// WEBPACK FOOTER //
// ./src/containers/invite_manager.js